import Axios from 'axios';
import service from '../../http/axios';

// 获取OSS上传下载地址
export const getUploadUrl = service({
  url: '/yinghe-api/third/getUploadUrl',
});

// 查询上传列表
export const queryUploadList = service({
  url: '/yinghe-api/imageDataManage/getUploadList',
});
// 保存上传地址
export const createUpload = service({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  url: '/yinghe-api/imageDataManage/upload',
});

// 上传并保存地址
export const handleUpload = async (
  { file, ...otherParams },
  onUploadProgress
) => {
  const fileName = Date.now() + '.zip';
  const uploadUrlResponse = await getUploadUrl({ fileName });
  await Axios.request({
    method: 'PUT',
    headers: { 'Content-Type': 'application/zip' },
    url: uploadUrlResponse.data.body.urls.uploadUrl,
    onUploadProgress,
    data: file,
  });
  return createUpload({
    ...otherParams,
    filePath: uploadUrlResponse.data.body.urls.downloadUrl,
    name: file.name,
  });
};
